// Copyright (C) Unite Digital LLC - All Rights Reserved.
// Unauthorized copying of this file, via any medium is strictly prohibited.
// Proprietary and confidential.
// Developed by Unite Digital LLC.

import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AppEvent, NavItem } from '@interfaces/interfaces';

@Component({
    selector: 'nav-item',
    templateUrl: './nav-item.component.html',
    styleUrls: ['./nav-item.component.scss'],
})
export class NavItemComponent {
    @Input() item: NavItem = null;
    @Input() isCollapsed: boolean;
    @Output() outEvent = new EventEmitter<AppEvent>();

    onClick(): void {
        this.outEvent.emit({
            context: 'navigate',
            data: this.item,
        });
    }
}
